export { default } from './CardTopCustomer'


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardTopCustomer/index.js